module.exports = __webpack_public_path__ + "static/media/logo_SU.eaaec1c9.png";